export var RouteName;
(function (RouteName) {
    RouteName["SigningRequest"] = "sign_wallet";
    RouteName["TransactionSigning"] = "transaction_signing";
    RouteName["EncryptionRequest"] = "encryption_request";
    RouteName["Setup"] = "setup_notifications";
    RouteName["Main"] = "main_notifications";
    RouteName["Settings"] = "settings_notifications";
    RouteName["Thread"] = "notifications_thread";
    RouteName["CantDecrypt"] = "cant_decrypt";
    RouteName["FailingGate"] = "failing_gate";
})(RouteName || (RouteName = {}));
//# sourceMappingURL=constants.js.map